module.exports = __webpack_public_path__ + "static/img/t52.92c1aab8.png";